// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"23":"learn-main","754":"register-main","792":"main","821":"eval-main"}[chunkId] || chunkId) + "." + {"23":"07ba7eb0","579":"8dda879b","754":"432eb815","792":"9c40d5f7","821":"bfee1945"}[chunkId] + ".css";
};